<p-table
  [(selection)]="selectedJob"
  (onLazyLoad)="load($event)"
  (onRowSelect)="onRowSelect(detailTable)"
  [columns]="selectedColumns"
  [exportFilename]="'MENU.JOBS' | translate"
  [lazy]="true"
  [loading]="loading"
  [paginator]="true"
  [rows]="10"
  [scrollable]="true"
  [showGridlines]="true"
  [sortOrder]="-1"
  [stripedRows]="true"
  [totalRecords]="totalRecords"
  [value]="jobs"
  #dt
  selectionMode="single"
  size="small"
  sortField="startTime">
  <ng-template pTemplate="caption">
    <div class="toolbar toolbar-single-row">
      <p-multiSelect
        [(ngModel)]="selectedColumns"
        [options]="columns"
        [placeholder]="'JOBS.SELECTED_COLUMNS_DEFAULT_LABEL' | translate"
        [selectedItemsLabel]="'JOBS.SELECTED_COLUMNS_LABEL' | translate"
        [style]="{ minWidth: '300px', maxWidth: '300px', height: '100%' }"
        appendTo="body"
        optionLabel="field">
        <ng-template let-column pTemplate="item">
          <div>{{ column.headerKey | translate }}</div>
        </ng-template>
      </p-multiSelect>
      <p-button
        (onClick)="dt._filter()"
        [label]="'ACTIONS.RELOAD' | translate"
        icon="fal fa-sync-alt"
        iconPos="left"
        type="button"></p-button>

      @if (isRodixAdmin()) {
        <p-button
          (onClick)="openRerunDialog(dt)"
          [disabled]="!selectedJob"
          [label]="'ACTIONS.RERUN' | translate"
          icon="fal fa-play"
          iconPos="left"
          type="button"></p-button>
      }

      <div class="spacer"></div>

      @if (isRodixAdmin()) {
        <p-button
          (onClick)="downloadXml()"
          [disabled]="!selectedJob"
          [label]="'JOBS.DOWNLOAD' | translate"
          icon="fal fa-download"
          iconPos="left"
          type="button"></p-button>
      }

      <p-button
        (onClick)="downloadCsv()"
        [disabled]="!selectedJob"
        icon="fal fa-file-alt"
        iconPos="left"
        label="CSV"
        type="button"></p-button>
    </div>
  </ng-template>

  <ng-template let-columns pTemplate="header">
    <tr>
      @for (col of columns; track col.field) {
        <th [pSortableColumn]="col.field" [style.max-width]="col.width" [style.min-width]="col.width">
          {{ col.headerKey | translate }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
    <tr>
      @for (col of columns; track col.field) {
        <th [style.max-width]="col.width" [style.min-width]="col.width">
          @switch (col.filterType) {
            @case ('date') {
              <p-datepicker
                (onInput)="dt.filter($any($event).target.value, col.field, 'date')"
                (onSelect)="dt.filter($event, col.field, 'date')"
                appendTo="body"
                dateFormat="dd.mm.yy"></p-datepicker>
            }
            @case ('datetime') {
              <p-datepicker
                (onInput)="dt.filter($any($event).target.value, col.field, 'date')"
                (onSelect)="dt.filter($event, col.field, 'date')"
                appendTo="body"
                dateFormat="dd.mm.yy"></p-datepicker>
            }
            @case ('status') {
              <p-select
                (onChange)="dt.filter($event.value, col.field, 'equals')"
                [options]="statusOptions"
                [placeholder]="'JOBS.STATUS_COLUMN_TITLE' | translate"
                [showClear]="true"
                appendTo="body"
                appScrollIntoView></p-select>
            }
            @case ('boolean') {
              <div
                (click)="cycleTriStateFilter($event, dt, col.field)"
                style="width: 100%; text-align: center; cursor: pointer">
                <p-checkbox
                  [binary]="true"
                  [indeterminate]="filters[col.field]?.value === undefined || filters[col.field]?.value === null"
                  [ngModel]="filters[col.field]?.value === true"
                  [readonly]="true"
                  [style]="{ 'pointer-events': 'none' }"></p-checkbox>
              </div>
            }
            @case ('betrieb') {
              <p-select
                (onChange)="dt.filter($event.value, col.field, 'equals')"
                [filter]="true"
                [filterBy]="'label'"
                [options]="betriebOptions"
                appendTo="body"
                appScrollIntoView></p-select>
            }
            @default {
              <input (input)="dt.filter($any($event.target).value, col.field, 'contains')" pInputText type="text" />
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-columns="columns" let-job pTemplate="body">
    <tr [pSelectableRow]="job">
      @for (col of columns; track col.field) {
        @switch (col.filterType) {
          @case ('date') {
            <td [style.max-width]="col.width" [style.min-width]="col.width">
              {{ job[col.field] | date: 'dd.MM.yyyy' }}
            </td>
          }
          @case ('datetime') {
            <td [style.max-width]="col.width" [style.min-width]="col.width">
              {{ job[col.field] | date: 'dd.MM.yyyy HH:mm:ss' }}
            </td>
          }
          @case ('status') {
            <td [style.max-width]="col.width" [style.min-width]="col.width">
              {{ 'JOBS.STATUS.' + job[col.field] | translate }}
            </td>
          }
          @case ('boolean') {
            <td [style.max-width]="col.width" [style.min-width]="col.width" style="text-align: center">
              @if (job[col.field] === true) {
                <i class="fal fa-check"></i>
              }
              @if (job[col.field] === false) {
                <i class="fal fa-minus"></i>
              }
            </td>
          }
          @case ('betrieb') {
            <td [style.max-width]="col.width" [style.min-width]="col.width">
              {{ betriebName[job[col.field]] }}
            </td>
          }
          @default {
            <td [style.max-width]="col.width" [style.min-width]="col.width">
              {{ job[col.field] }}
            </td>
          }
        }
      }
    </tr>
  </ng-template>
</p-table>

<p-table
  (onRowExpand)="loadXmlEntry($event)"
  [columns]="groupedLogColumns"
  [ngStyle]="{ visibility: groupedLogs.length === 0 ? 'hidden' : 'visible' }"
  [showGridlines]="true"
  [stripedRows]="true"
  [style]="{ 'margin-top': '4rem' }"
  [value]="groupedLogs"
  #detailTable
  dataKey="id"
  rowExpandMode="single"
  size="small">
  <ng-template let-columns pTemplate="header">
    <tr>
      <th style="width: 3em"></th>
      @for (col of columns; track col.field) {
        <th [pSortableColumn]="col.field" [style.max-width]="col.width" [style.min-width]="col.width">
          {{ col.headerKey | translate }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-columns="columns" let-expanded="expanded" let-log pTemplate="body">
    <tr>
      <td>
        <a [pRowToggler]="log" href="#">
          <i [ngClass]="expanded ? 'fal fa-chevron-down' : 'fal fa-chevron-right'"></i>
        </a>
      </td>
      @for (col of columns | filter: 'visible' : true; track col.field) {
        <td [style.max-width]="col.width" [style.min-width]="col.width">
          @if (col.filterType === 'number') {
            {{ log[col.field] }}
          }
          @if (col.filterType === 'type') {
            {{ 'JOBS.LOG_ERROR.' + log[col.field] | translate }}
          }
          @if (col.filterType === 'loglevel') {
            {{ 'JOBS.LOG_LEVEL.' + log[col.field] | translate }}
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template let-columns="columns" let-rowData pTemplate="expandedrow">
    <tr>
      <td [attr.colspan]="columns.length + 1">
        @if (xmlEntries) {
          @if (xmlEntryTypes.length > 1) {
            @for (type of xmlEntryTypes; track $index) {
              <p-panel [header]="type" [style]="{ margin: '1rem' }">
                <div style="display: flex; width: 100%; flex: 1">
                  <app-jobs-entry-table
                    [columns]="xmlEntryColumns[type]"
                    [entries]="xmlEntries[type]"
                    [jobId]="selectedJob?.id"></app-jobs-entry-table>
                </div>
              </p-panel>
            }
          } @else {
            <div style="display: flex; width: 100%; flex: 1">
              <app-jobs-entry-table
                [columns]="xmlEntryColumns[xmlEntryTypes[0]]"
                [entries]="xmlEntries[xmlEntryTypes[0]]"
                [jobId]="selectedJob?.id"></app-jobs-entry-table>
            </div>
          }
          <ng-template #single>
            <div style="display: flex; width: 100%; flex: 1">
              <app-jobs-entry-table
                [columns]="xmlEntryColumns[xmlEntryTypes[0]]"
                [entries]="xmlEntries[xmlEntryTypes[0]]"
                [jobId]="selectedJob?.id"></app-jobs-entry-table>
            </div>
          </ng-template>
        } @else {
          <div style="overflow: hidden">
            <p-progressSpinner [style]="{ 'margin-left': 'calc(50% - 50px)' }"></p-progressSpinner>
          </div>
        }
        <ng-template #loading>
          <div style="overflow: hidden">
            <p-progressSpinner [style]="{ 'margin-left': 'calc(50% - 50px)' }"></p-progressSpinner>
          </div>
        </ng-template>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="rerunDialogVisible"
  [baseZIndex]="10000"
  [draggable]="false"
  [header]="'JOBS.RERUN_TITLE' | translate"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '50vw' }">
  <p translate>JOBS.RERUN_DETAIL</p>
  <p-footer>
    <p-button
      (click)="rerun(true, dt)"
      [label]="'JOBS.RERUN_ALL' | translate"
      icon="fal fa-fast-forward"
      styleClass="p-button-danger"></p-button>
    <p-button
      (click)="rerun(false, dt)"
      [label]="'JOBS.RERUN_ONE' | translate"
      icon="fal fa-step-forward"
      styleClass="p-button-warning"></p-button>
    <p-button
      (click)="rerunDialogVisible = false"
      [label]="'ACTIONS.CANCEL' | translate"
      icon="fal fa-stop-circle"
      styleClass="p-button-secondary"></p-button>
  </p-footer>
</p-dialog>
